import styles from "./Menu.desktop.module.css";
import React from "react";
import {
  FaBagShopping,
  FaBorderAll,
  FaCalendarCheck,
  FaChevronDown,
  FaChevronUp,
  FaGear,
  FaInfo,
  FaLandmark,
} from "react-icons/fa6";
import canEditMarket from "../../../security/CanEditMarket.ts";
import canCreateMarketComponent from "../../../security/CanCreateMarketComponent.ts";
import ObjectSelectionView from "../../object-selection/ObjectSelection.view.tsx";
import MarketSelectionView from "../../market-selection/MarketSelection.view.tsx";
import canViewMarketComponentHistory from "../../../security/CanViewMarketComponentHistory.ts";
import MenuGeneralView from "./Menu.General.view.tsx";
import HistoryDialogView from "../../../dialogs/history-dialog/HistoryDialog.view.tsx";
import MarketPropertiesDialogView from "../../../dialogs/market-properties-dialog/MarketPropertiesDialog.view.tsx";
import MarketComponentDetailsDialogView from "../../../dialogs/market-component-details-dialog/MarketComponentDetailsDialog.view.tsx";
import { useMenuController } from "../Menu.controller.ts";
import { useTranslation } from "react-i18next";
import isAdmin from "../../../security/IsAdmin.ts";

export default function MenuMarketManagementView() {
  const { t } = useTranslation();
  const {
    handleHistoryDialogCloseClick,
    handleMarketPropertiesDialogCloseClick,
    handleDetailsDialogCloseClick,
    handleMarketPropertiesClick,
    handleAdministrationClick,
    handleObjectSelectionClick,
    handleMarketSelectionClick,
    handleMarketSelectionChanged,
    handleHistoryClick,
    handleRedRackClick,
    isHistoryDialogOpen,
    selectedValue,
    isMarketPropertiesDialogOpen,
    isDetailsDialogOpen,
    marketComponentForValidation,
    isObjectSelectionOpen,
    isMarketSelectionOpen,
  } = useMenuController();

  return (
    <>
      {isHistoryDialogOpen && (
        <HistoryDialogView
          id={selectedValue}
          isMarketId
          showMarketComponentName
          name={t("ui.historyDialogMarketHeading")}
          handleDialogCloseClick={handleHistoryDialogCloseClick}
        />
      )}

      {isMarketPropertiesDialogOpen && (
        <MarketPropertiesDialogView
          handleDialogCloseClick={handleMarketPropertiesDialogCloseClick}
        />
      )}

      {isDetailsDialogOpen && (
        <MarketComponentDetailsDialogView
          marketComponent={marketComponentForValidation}
          handleDialogCloseClick={handleDetailsDialogCloseClick}
        />
      )}

      <MenuGeneralView>
        {/* Market Properties Selection */}
        {canEditMarket() && (
          <>
            <div
              className={styles.menuItemContainer}
              onClick={handleMarketPropertiesClick}
            >
              <div className={styles.menuItemIconContainer}>
                <FaGear className={styles.icon} />
              </div>
              <div className={styles.menuItemLabelContainer}>
                <p className={styles.menuItemLabel}>
                  {t("ui.marketProperties")}
                </p>
              </div>
            </div>

            <hr className={styles.horizontalSeparator} />
          </>
        )}

        {/* Administration */}
        {isAdmin() && (
          <>
            <div
              className={styles.menuItemContainer}
              onClick={handleAdministrationClick}
            >
              <div className={styles.menuItemIconContainer}>
                <FaLandmark className={styles.icon} />
              </div>
              <div className={styles.menuItemLabelContainer}>
                <p className={styles.menuItemLabel}>{t("ui.administration")}</p>
              </div>
            </div>

            <hr className={styles.horizontalSeparator} />
          </>
        )}

        {/* Object Selection */}
        {canCreateMarketComponent() && (
          <>
            <div className={styles.objectSelectionContainer}>
              <div>
                <div
                  className={styles.menuItemContainer}
                  onClick={handleObjectSelectionClick}
                >
                  <div className={styles.menuItemIconContainer}>
                    <FaBorderAll className={styles.icon} />
                  </div>
                  <div className={styles.menuItemLabelContainer}>
                    <p className={styles.menuItemLabel}>
                      {t("ui.objectSelection")}
                    </p>
                  </div>
                  <div className={styles.menuItemChevronContainer}>
                    {!isObjectSelectionOpen && (
                      <FaChevronDown className={styles.chevron} />
                    )}
                    {isObjectSelectionOpen && (
                      <FaChevronUp className={styles.chevron} />
                    )}
                  </div>
                </div>
              </div>
              <ObjectSelectionView
                isObjectSelectionOpen={isObjectSelectionOpen}
              />
            </div>

            <hr className={styles.horizontalSeparator} />
          </>
        )}

        {/* Market Selection */}
        <>
          <div className={styles.objectSelectionContainer}>
            <div>
              <div
                className={styles.menuItemContainer}
                onClick={handleMarketSelectionClick}
              >
                <div className={styles.menuItemIconContainer}>
                  <FaBagShopping className={styles.icon} />
                </div>
                <div className={styles.menuItemLabelContainer}>
                  <p className={styles.menuItemLabel}>
                    {t("ui.marketSelection")}
                  </p>
                </div>
                <div className={styles.menuItemChevronContainer}>
                  {!isMarketSelectionOpen && (
                    <FaChevronDown className={styles.chevron} />
                  )}
                  {isMarketSelectionOpen && (
                    <FaChevronUp className={styles.chevron} />
                  )}
                </div>
              </div>
            </div>
            <MarketSelectionView
              isMarketSelectionOpen={isMarketSelectionOpen}
              onChange={handleMarketSelectionChanged}
              selectedValue={selectedValue}
            />
          </div>

          <hr className={styles.horizontalSeparator} />
        </>

        {/* History */}
        {canViewMarketComponentHistory() && (
          <>
            <div
              className={styles.menuItemContainer}
              onClick={handleHistoryClick}
            >
              <div className={styles.menuItemIconContainer}>
                <FaInfo className={styles.icon} />
              </div>
              <div className={styles.menuItemLabelContainer}>
                <p className={styles.menuItemLabel}>{t("ui.history")}</p>
              </div>
            </div>

            <hr className={styles.horizontalSeparator} />
          </>
        )}

        {/* Red Rack */}
        <>
          <div
            className={styles.menuItemContainer}
            onClick={handleRedRackClick}
          >
            <div className={styles.menuItemIconContainer}>
              <FaCalendarCheck className={styles.icon} />
            </div>
            <div className={styles.menuItemLabelContainer}>
              <p className={styles.menuItemLabel}>{t("ui.redRackButton")}</p>
            </div>
          </div>

          <hr className={styles.horizontalSeparator} />
        </>
      </MenuGeneralView>
    </>
  );
}
